// Police Bharti Test Questions - Sample Set
export const policeTests = [
  {
    id: 'police-test-1',
    title: 'Police Bharti - General Knowledge Set 1',
    titleMr: 'पोलीस भरती - सामान्य ज्ञान संच १',
    category: 'gk',
    price: 10,
    published: true,
    questions: [
      {
        question: "Who is the current Chief Minister of Maharashtra?",
        questionMr: "महाराष्ट्राचे सध्याचे मुख्यमंत्री कोण आहेत?",
        options: ["Eknath Shinde", "Uddhav Thackeray", "Devendra Fadnavis", "Sharad Pawar"],
        optionsMr: ["एकनाथ शिंदे", "उद्धव ठाकरे", "देवेंद्र फडणवीस", "शरद पवार"],
        correct: 0,
        explanation: "Eknath Shinde is the current Chief Minister of Maharashtra.",
        explanationMr: "एकनाथ शिंदे हे महाराष्ट्राचे सध्याचे मुख्यमंत्री आहेत."
      },
      {
        question: "What is the capital of India?",
        questionMr: "भारताची राजधानी कोणती आहे?",
        options: ["Mumbai", "New Delhi", "Kolkata", "Chennai"],
        optionsMr: ["मुंबई", "नवी दिल्ली", "कोलकाता", "चेन्नई"],
        correct: 1,
        explanation: "New Delhi is the capital of India.",
        explanationMr: "नवी दिल्ली ही भारताची राजधानी आहे."
      },
      {
        question: "Which article of the Indian Constitution deals with Right to Equality?",
        questionMr: "भारतीय संविधानाचा कोणता कलम समानतेच्या अधिकाराशी संबंधित आहे?",
        options: ["Article 12", "Article 14", "Article 16", "Article 18"],
        optionsMr: ["कलम १२", "कलम १४", "कलम १६", "कलम १८"],
        correct: 1,
        explanation: "Article 14 of the Indian Constitution deals with Right to Equality.",
        explanationMr: "भारतीय संविधानाचा कलम १४ समानतेच्या अधिकाराशी संबंधित आहे."
      },
      {
        question: "Who is known as the Father of the Indian Constitution?",
        questionMr: "भारतीय संविधानाचे जनक कोण म्हणून ओळखले जातात?",
        options: ["Mahatma Gandhi", "Dr. B.R. Ambedkar", "Jawaharlal Nehru", "Sardar Patel"],
        optionsMr: ["महात्मा गांधी", "डॉ. बी.आर. आंबेडकर", "जवाहरलाल नेहरू", "सरदार पटेल"],
        correct: 1,
        explanation: "Dr. B.R. Ambedkar is known as the Father of the Indian Constitution.",
        explanationMr: "डॉ. बी.आर. आंबेडकर यांना भारतीय संविधानाचे जनक म्हणून ओळखले जाते."
      },
      {
        question: "What is the full form of IPC?",
        questionMr: "IPC चा पूर्ण रूप काय आहे?",
        options: ["Indian Penal Code", "Indian Police Code", "Indian Public Code", "Indian Procedure Code"],
        optionsMr: ["भारतीय दंड संहिता", "भारतीय पोलीस संहिता", "भारतीय सार्वजनिक संहिता", "भारतीय प्रक्रिया संहिता"],
        correct: 0,
        explanation: "IPC stands for Indian Penal Code.",
        explanationMr: "IPC म्हणजे भारतीय दंड संहिता."
      },
      {
        question: "In which year was the Indian Police Act enacted?",
        questionMr: "भारतीय पोलीस कायदा कोणत्या वर्षी लागू करण्यात आला?",
        options: ["1858", "1860", "1861", "1865"],
        optionsMr: ["१८५८", "१८६०", "१८६१", "१८६५"],
        correct: 2,
        explanation: "The Indian Police Act was enacted in 1861.",
        explanationMr: "भारतीय पोलीस कायदा १८६१ मध्ये लागू करण्यात आला."
      },
      {
        question: "What is the emergency number for police in India?",
        questionMr: "भारतात पोलिसांचा आपत्कालीन नंबर काय आहे?",
        options: ["100", "101", "102", "108"],
        optionsMr: ["१००", "१०१", "१०२", "१०८"],
        correct: 0,
        explanation: "100 is the emergency number for police in India.",
        explanationMr: "१०० हा भारतात पोलिसांचा आपत्कालीन नंबर आहे."
      },
      {
        question: "Who is the current Director General of Police (DGP) of Maharashtra?",
        questionMr: "महाराष्ट्राचे सध्याचे पोलीस महासंचालक (DGP) कोण आहेत?",
        options: ["Sanjay Pandey", "Rajnish Seth", "Rashmi Shukla", "Hemant Nagrale"],
        optionsMr: ["संजय पांडे", "राजनीश सेठ", "रश्मी शुक्ला", "हेमंत नागराळे"],
        correct: 2,
        explanation: "Rashmi Shukla is the current DGP of Maharashtra.",
        explanationMr: "रश्मी शुक्ला या महाराष्ट्राच्या सध्याच्या पोलीस महासंचालक आहेत."
      },
      {
        question: "What does CrPC stand for?",
        questionMr: "CrPC चा अर्थ काय आहे?",
        options: ["Criminal Procedure Code", "Civil Procedure Code", "Criminal Police Code", "Civil Police Code"],
        optionsMr: ["फौजदारी प्रक्रिया संहिता", "दिवाणी प्रक्रिया संहिता", "फौजदारी पोलीस संहिता", "दिवाणी पोलीस संहिता"],
        correct: 0,
        explanation: "CrPC stands for Criminal Procedure Code.",
        explanationMr: "CrPC म्हणजे फौजदारी प्रक्रिया संहिता."
      },
      {
        question: "Which section of IPC deals with murder?",
        questionMr: "IPC चा कोणता कलम हत्येशी संबंधित आहे?",
        options: ["Section 300", "Section 302", "Section 304", "Section 306"],
        optionsMr: ["कलम ३००", "कलम ३०२", "कलम ३०४", "कलम ३०६"],
        correct: 1,
        explanation: "Section 302 of IPC deals with murder.",
        explanationMr: "IPC चा कलम ३०२ हत्येशी संबंधित आहे."
      }
    ]
  },
  {
    id: 'police-test-2',
    title: 'Police Bharti - Mathematics Set 1',
    titleMr: 'पोलीस भरती - गणित संच १',
    category: 'math',
    price: 10,
    published: true,
    questions: [
      {
        question: "If a police officer runs 5 km in 25 minutes, what is his speed in km/hr?",
        questionMr: "जर एक पोलीस अधिकारी २५ मिनिटात ५ किमी धावतो, तर त्याचा वेग किमी/तास मध्ये किती आहे?",
        options: ["10 km/hr", "12 km/hr", "15 km/hr", "20 km/hr"],
        optionsMr: ["१० किमी/तास", "१२ किमी/तास", "१५ किमी/तास", "२० किमी/तास"],
        correct: 1,
        explanation: "Speed = Distance/Time = 5 km / (25/60) hr = 5 × (60/25) = 12 km/hr",
        explanationMr: "वेग = अंतर/वेळ = ५ किमी / (२५/६०) तास = ५ × (६०/२५) = १२ किमी/तास"
      },
      {
        question: "What is 25% of 80?",
        questionMr: "८० चा २५% किती आहे?",
        options: ["15", "20", "25", "30"],
        optionsMr: ["१५", "२०", "२५", "३०"],
        correct: 1,
        explanation: "25% of 80 = (25/100) × 80 = 20",
        explanationMr: "८० चा २५% = (२५/१००) × ८० = २०"
      },
      {
        question: "If 3x + 7 = 22, then x = ?",
        questionMr: "जर ३x + ७ = २२, तर x = ?",
        options: ["3", "4", "5", "6"],
        optionsMr: ["३", "४", "५", "६"],
        correct: 2,
        explanation: "3x + 7 = 22, so 3x = 15, therefore x = 5",
        explanationMr: "३x + ७ = २२, म्हणून ३x = १५, त्यामुळे x = ५"
      },
      {
        question: "The average of 10, 20, 30, 40 is:",
        questionMr: "१०, २०, ३०, ४० ची सरासरी आहे:",
        options: ["20", "25", "30", "35"],
        optionsMr: ["२०", "२५", "३०", "३५"],
        correct: 1,
        explanation: "Average = (10+20+30+40)/4 = 100/4 = 25",
        explanationMr: "सरासरी = (१०+२०+३०+४०)/४ = १००/४ = २५"
      },
      {
        question: "What is the area of a square with side 8 cm?",
        questionMr: "८ सेमी बाजू असलेल्या चौरसाचे क्षेत्रफळ किती आहे?",
        options: ["32 sq cm", "64 sq cm", "16 sq cm", "48 sq cm"],
        optionsMr: ["३२ चौ सेमी", "६४ चौ सेमी", "१६ चौ सेमी", "४८ चौ सेमी"],
        correct: 1,
        explanation: "Area of square = side × side = 8 × 8 = 64 sq cm",
        explanationMr: "चौरसाचे क्षेत्रफळ = बाजू × बाजू = ८ × ८ = ६४ चौ सेमी"
      },
      {
        question: "If a car travels 120 km in 2 hours, what is its speed?",
        questionMr: "जर एक कार २ तासात १२० किमी प्रवास करते, तर तिचा वेग किती आहे?",
        options: ["50 km/hr", "60 km/hr", "70 km/hr", "80 km/hr"],
        optionsMr: ["५० किमी/तास", "६० किमी/तास", "७० किमी/तास", "८० किमी/तास"],
        correct: 1,
        explanation: "Speed = Distance/Time = 120 km / 2 hr = 60 km/hr",
        explanationMr: "वेग = अंतर/वेळ = १२० किमी / २ तास = ६० किमी/तास"
      },
      {
        question: "What is 15% of 200?",
        questionMr: "२०० चा १५% किती आहे?",
        options: ["25", "30", "35", "40"],
        optionsMr: ["२५", "३०", "३५", "४०"],
        correct: 1,
        explanation: "15% of 200 = (15/100) × 200 = 30",
        explanationMr: "२०० चा १५% = (१५/१००) × २०० = ३०"
      },
      {
        question: "The perimeter of a rectangle with length 12 cm and breadth 8 cm is:",
        questionMr: "१२ सेमी लांबी आणि ८ सेमी रुंदी असलेल्या आयताची परिमिती आहे:",
        options: ["32 cm", "40 cm", "48 cm", "56 cm"],
        optionsMr: ["३२ सेमी", "४० सेमी", "४८ सेमी", "५६ सेमी"],
        correct: 1,
        explanation: "Perimeter = 2(length + breadth) = 2(12 + 8) = 2 × 20 = 40 cm",
        explanationMr: "परिमिती = २(लांबी + रुंदी) = २(१२ + ८) = २ × २० = ४० सेमी"
      },
      {
        question: "If 20% of a number is 40, what is the number?",
        questionMr: "जर एका संख्येचा २०% हा ४० आहे, तर ती संख्या किती आहे?",
        options: ["160", "180", "200", "220"],
        optionsMr: ["१६०", "१८०", "२००", "२२०"],
        correct: 2,
        explanation: "Let the number be x. 20% of x = 40, so x/5 = 40, therefore x = 200",
        explanationMr: "संख्या x असू द्या. x चा २०% = ४०, म्हणून x/५ = ४०, त्यामुळे x = २००"
      },
      {
        question: "What is the next number in the series: 5, 10, 20, 40, ?",
        questionMr: "या मालिकेतील पुढील संख्या काय आहे: ५, १०, २०, ४०, ?",
        options: ["60", "70", "80", "90"],
        optionsMr: ["६०", "७०", "८०", "९०"],
        correct: 2,
        explanation: "Each number is multiplied by 2. So 40 × 2 = 80",
        explanationMr: "प्रत्येक संख्या २ ने गुणली जाते. म्हणून ४० × २ = ८०"
      }
    ]
  }
]